import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../core/config';

@Injectable()
export class ProceduresService {
   constructor(
      private http: HttpClient,
      private configService: ConfigService
   ) {
   }
   getProceduresList(showDeletedRecords): Observable<any> {
      return this.http.get(`${this.configService.apiUrl}/procedures/getProceduresList/${showDeletedRecords}`);
   }

   deleteProcedure(params): Observable<any> {
      return this.http.post(`${this.configService.apiUrl}/procedures/deleteProcedure`, params);
   }
   deleteProcedureAlias(id): Observable<any> {
      return this.http.delete(`${this.configService.apiUrl}/procedures/deleteProcedureAlias/${id}`);
   }
   assignChildProcedure(params): Observable<any> {
      return this.http.post(`${this.configService.apiUrl}/procedures/assignChildProcedure`, params);
   }
   removeChildProcedure(params): Observable<any> {
      return this.http.post(`${this.configService.apiUrl}/procedures/removeChildProcedure`, params);
   }
   addProcedure(params): Observable<any> {
      return this.http.post(`${this.configService.apiUrl}/procedures/addProcedure`,params );
   }
}
